import React from "react";
import { Quote } from "lucide-react";
import { useI18n } from "../i18n";

const AVATARS = [
  "https://images.unsplash.com/photo-1667133295308-9ef24f71952e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc4NzcwNDE3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1588776813941-dcf9c55e84d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxkZW50aXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc4NzcwNDE3fDA&ixlib=rb-4.1.0&q=85",
];

const Testimonials = () => {
  const { t } = useI18n();
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-600 mb-4">
            {t.testimonials.eyebrow}
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-slate-900">
            {t.testimonials.title}
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {t.testimonials.items.map((item, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-slate-50 border border-slate-200 rounded-2xl p-8 md:p-10 transition-all hover:-translate-y-1 hover:shadow-lg"
            >
              <Quote className="w-8 h-8 text-sky-600" />
              <blockquote className="mt-6 font-display text-xl md:text-2xl font-medium text-slate-900 leading-snug">
                "{item.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <img
                  src={AVATARS[i]}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-white shadow"
                />
                <div>
                  <div className="font-semibold text-slate-900">{item.name}</div>
                  <div className="text-sm text-slate-500">{item.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
